import { Capacitor } from "@capacitor/core";

/** Custom URL scheme registered in ios/App/App/Info.plist and AndroidManifest.xml. */
export const NATIVE_AUTH_CALLBACK = "com.pawseum.app://callback";

/** @deprecated Use NATIVE_AUTH_CALLBACK */
export const IOS_AUTH_CALLBACK = NATIVE_AUTH_CALLBACK;

/** Auth0 login `redirect_uri` per platform. */
export function getRedirectUri(): string {
  if (Capacitor.isNativePlatform()) {
    return NATIVE_AUTH_CALLBACK;
  }
  return `${window.location.origin}/`;
}

/**
 * Auth0 `logoutParams.returnTo` per platform.
 *
 * Web: `window.location.origin` — Auth0 redirects back to the app origin.
 *
 * Native: the custom URL scheme. Using `window.location.origin` here would
 * resolve to `capacitor://localhost`, which the OS cannot deep-link back to.
 * The `appUrlOpen` listener in `useAuth0DeepLink` catches the callback, closes
 * the browser sheet, and lands the user on `/`.
 */
export function getLogoutReturnTo(): string {
  if (Capacitor.isNativePlatform()) {
    return NATIVE_AUTH_CALLBACK;
  }
  return window.location.origin;
}
